import { ChangeDetectorRef, Component, NgZone, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { TranslateService } from '../../../../../../services/translate.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';

import { NotificationsService } from '../../../../../common/services/notifications.service';
import { UserService } from '../../../../../../services/user.service';
import { WksCentralService } from '../../../../services/wks-central.service';

import { NotifUsers } from '../../../../../../models/common.model';
import { PartsStock, WksWorksModel, WksWorksTracking, WorkEquipmentRef, WorkEquipments, WorkInputEvent, WorkJsonData } from '../../../../models/wks-works.model';
import { WksBusinessModel } from '../../../../models/wks-business.model';
import { MatTabChangeEvent } from '@angular/material/material';
import { ParamPartsSuppliesModel, PartsRequirement, TaskrefJsonModel, TasksActionsContentModel, TasksActionsModel, WksTasksModel } from '../../../../models/wks-param.model';
import { InternationalsFormats, LabelValue } from '../../../../../../models/data.model';
import { WksEquipmentModel } from '../../../../models/wks-equipment.model';
import { RessourcesService } from '../../../../../../job/common/services/ressources.service';
import { WksEntityModel } from '../../../../models/wks-entity.model';
import { DataUpstream, WksInfolinks } from '../../../../models/wks-common.model';

import { ModalCommonComponent } from '../../../../../common/components/modal-common/modal-common.component';
import { CommonMethods } from '../../../../../../job/common/tools/commonMethods';
import { MessageDisplay, ToolApiResponse, ToolArgs, ToolKeyValue } from '../../../../../../models/common.model';
import { WksWorksService } from '../../../..//services/wks-works.service';

@Component({
  selector: 'mdi-works-stock-movements',
  templateUrl: './works-stock-movements.component.html',
  styleUrls: ['./works-stock-movements.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class WorksStockMovementsComponent implements OnInit {
  @ViewChild('searchModal', {read: TemplateRef, static: false}) searchModal: TemplateRef<any>;
  private readonly onDestroy = new Subject<void>();
  wksEntity: WksEntityModel;
  notificationsSubscription: Subscription;
  initializeScreen: boolean;
  displayParts: boolean;
  isOkToReserve: boolean;
  rowsWorks: {
    workId: string;
    workRef: string;
    ownerId: string;
    ownerDesign: string;
    workLabel: string;
    workStatut: string;
    dateOperation: string;
    isSelected: boolean;
    isCollapsed: boolean;
    odd: boolean;
    isArchivable: boolean;
    // workTasksContent: WksTasksModel[];
    workTasksList: {
      workTask: WksTasksModel;
      taskEquip: WorkEquipments[];
    }[];
    partsStock: PartsStock;
    stdEntity: string;
    work: WksWorksModel;
    wksInfolinks: WksInfolinks;
  }[];
  timeFormat: string;

  idxToDisplay: number;
  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
  };
  internationalsFormats: InternationalsFormats;
  dateFormat: string;
  dateFormatMoment: string;
  dateTimeFormat: string;
  dataLabelCur: string[];

  isLoadingData: boolean;
  displayErrorMsg: boolean;
  errorMsg: string;
  labelsTabs: string[];
  tabSelected: number;
  readStock: boolean;
  dataUpstream: DataUpstream;

  currentWorkRow: number;
  readOnly: boolean;
  constructor(private _userService: UserService,
              private _translateService: TranslateService,
              private _wksCentralService: WksCentralService,
              private _notificationsService: NotificationsService,
              private _ressourcesService: RessourcesService,
              private toastr: ToastrService,
              private _zone: NgZone,
              private snackBar: MatSnackBar,
              private _dialog: MatDialog,
              private _wksWorksService: WksWorksService
            ) { }

  ngOnInit(): void {
    if (this._userService.getUserLogged() === undefined ) { return; }
    this.initAllBooleaans();
    this.initAllParam();
    this.settingFormats();
    this.initVariables();
    this.subscribeNotifications();
    this.getWorksList('wharehouseMan-new', 0);
    this.initializeScreen = true;
  }
  initAllBooleaans(): void {
    this.initializeScreen = false;
    this.displayParts = false;
    this.isOkToReserve = false;
    this.isLoadingData = true;
    this.displayErrorMsg = false;
    this.readStock = false;
    this.readOnly = false;
  }
  initVariables(): void {
    this.tabSelected = 0;
    this.timeFormat = this._translateService.getLocalFmt('timeFormat');
    this.rowsWorks = [];

    this.dataLabelCur = [];
    this.dataLabelCur[0] = this._translateService.instant('suppliesLabel');
    this.dataLabelCur[1] = this._translateService.instant('brandRef');
    this.dataLabelCur[2] = this._translateService.instant('replacesReference');
    this.dataLabelCur[3] = this._translateService.instant('billingUnit');
    this.dataLabelCur[4] = this._translateService.instant('quantity');
    this.dataLabelCur[5] = this._translateService.instant('actionTask');
    this.dataLabelCur[6] = this._translateService.instant('inStock');
    this.dataLabelCur[7] = this._translateService.instant('okToReserve');
    this.dataLabelCur[8] = this._translateService.instant('nws_order_ref');
    this.labelsTabs = [];
    this.labelsTabs[0] = 'deliveriesNew';
    this.labelsTabs[1] = 'deliveriesWaiting';
    this.labelsTabs[2] = 'deliveriesArchives';
  }
  settingFormats(): void {
    const otherData = JSON.parse(this._wksCentralService.getWksEntityCur().otherData);
    const intFormat = otherData.internationnalFormat;
    this.numberFormat = {
      locale: this._ressourcesService.getFormat(intFormat, 'numbers', 'locale'),
      minDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this._ressourcesService.getFormat(intFormat, 'numbers', 'currency'),
    };
  }
  initAllParam() {

    this.wksEntity = this._wksCentralService.getWksEntityCur();
    const otherData = JSON.parse(this.wksEntity.otherData);
    const internationnalFormat = otherData.internationnalFormat;
    this.internationalsFormats = this._ressourcesService.getIntFormat(internationnalFormat);
    for (const fmtCur of this.internationalsFormats.datetime) {
      if (fmtCur.name === 'dateFormat') {
        this.dateFormat = fmtCur.value;
        this.dateFormatMoment = fmtCur.value;
        this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
        this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
      }
      if (fmtCur.name === 'timeFormat') {
        this.dateTimeFormat = fmtCur.value;
        this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
        this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
      }
    }
  }
  
  subscribeNotifications(): void {
    this.notificationsSubscription = this._notificationsService.connectNotif(this._userService.getUserLogged().usergroup)
    .pipe(takeUntil(this.onDestroy))
    .subscribe({
      next: notif => {
        this._zone.run(() => {
          const msgData: NotifUsers = JSON.parse(notif);
          // console.log(msgData.recipients, ' ' + msgData.contentMessage);
          if (msgData.recipients === this._userService.getUserLogged().entity && msgData.objectMessage === 'notifStock') {
            const contentMsg: WksInfolinks = JSON.parse(msgData.contentMessage);
            // this.dataSource.data.splice(0, 0, workMsg);
            // this.rows = [...this.rows];
            this.getWorkData(contentMsg.inflUuididentifier)
            .then ((workData: WksWorksModel) => {
              if (workData.workStatut === 'accepted' || workData.workStatut === 'approved') {
                const rowsList = JSON.parse(JSON.stringify(this.rowsWorks));
                const rowData = [contentMsg, workData];
                const newRow = this.buildRowWork('wharehouseMan-new', rowData);
                rowsList.unshift(newRow);
                this.rowsWorks = [...rowsList];
                // this.rowsWorks.splice(0, 0, newRow);
                this.settingOddEven();
              }
              setTimeout(() => {}, 500); // JLG - 2025-06-04 : nécessaire pour éviter une reconnexion immédiate au serveur qui génère l'erreur 503
              //  this.cd.detectChanges(); // Forcer Angular à re-vérifier la vue
              // const messageCur = this._translate.getTranslate('work') + ' : ' + workMsg.workRef + ' --- > ' + this._translate.getTranslate(workMsg.workStatut);
              // this.openSnackBar(messageCur, 'No-Action');
            });
          }
        });
      }
    });
  }
  
  buildRowWork(_inflAppli: string, rowData: any[]): any {

    const wksInfolinks = rowData[0] as WksInfolinks;
    const workData = rowData[1] as WksWorksModel;
    let dateOperationTmp ;
    // const zuluDate = new Date(wksInfolinks.stdCreation);
    // console.log(zuluDate.toString()); // ou .toLocaleString() selon les besoins
    if (wksInfolinks.recordedDate.toString().includes('T')) {
      dateOperationTmp = CommonMethods.dateToString(wksInfolinks.recordedDate, 'unixM', this.timeFormat);
    } else  {
      dateOperationTmp = CommonMethods.dateToString(wksInfolinks.recordedDate, 'json', this.timeFormat);
    }
    const partsStockTmp: PartsStock = {
      parts: undefined
    };
    interface TaskLocalTmp {
        workTask: WksTasksModel;
        taskEquip: WksEquipmentModel[];
      }
     interface NewRow {
      workId: string;
      workRef: string;
      ownerId: string;
      ownerDesign: string;
      workLabel: string;
      workStatut: string;
      dateOperation: string;
      isSelected: boolean;
      isCollapsed: boolean;
      odd: boolean;
      isArchivable: boolean;
      workTasksList: TaskLocalTmp[];
      partsStock: any; // à typer idéalement aussi
      stdEntity: any;
      work: any;
      wksInfolinks: any;
    } 
    const newRow: NewRow =  {
      workId: workData.id,
      workRef: workData.workRef,
      ownerId: workData.ownerId,
      ownerDesign : workData.workCustomerName,
      workLabel: workData.workObject,
      workStatut: workData.workStatut,
      // dateOperation: moment(wksInfolinks.stdCreation).format(environment.fmtDateTimeTZ),
      // dateOperation: GridTools.date_json('' + wksInfolinks.stdCreation, this._translateService.getLocalFmt('timeFormat')),
      dateOperation: dateOperationTmp,
      isSelected: false,
      isCollapsed: true,
      odd: false,
      isArchivable: false,
      workTasksList: [],
      partsStock: partsStockTmp,
      stdEntity: workData.stdEntity,
      work: workData,
      wksInfolinks: wksInfolinks
    };
    for (const taskCur of workData.workTasksContent) {
      const taskrefJson = JSON.parse(taskCur.taskrefJson)  as TaskrefJsonModel;
      const tasksActionsContent = taskrefJson.tasksActionsContent;
      const taskEquipments = this._wksWorksService.getListEquipments(tasksActionsContent, workData.mainEquipmentObject, workData.subEquipmentsObject );
      const taskLocal = {
        workTask: taskCur,
        taskEquip: taskEquipments
      };
      newRow.partsStock.parts = this._wksWorksService.initListPartsFromTasks(workData);
      // newRow.partsRequirementTasks = this._wksWorksService.initListPartsFromTasks(workData);
      if (_inflAppli !== 'wharehouseMan-new') {
        if (workData.workJsonData) {
          const workJsonData = JSON.parse(workData.workJsonData) as WorkJsonData;
          if (workJsonData.partsStock) {
            newRow.partsStock = JSON.parse(JSON.stringify(workJsonData.partsStock));
            newRow.isArchivable = this.ctrlIsArchivable(workJsonData.partsStock);
          }
        }
      }
      newRow.workTasksList.push(taskLocal);
    }

    return newRow;
  }
  ctrlIsArchivable(partsStock: PartsStock): boolean {
    let isArchivable = true;
    for (const itemPart of partsStock.parts ) {
      const stockTransacts = itemPart.stockTransacts;
      let delivredQty = 0;
      for (const transact of stockTransacts) {
        delivredQty +=  transact.outputStock;
        delivredQty -=  transact.inputStock;
      }
      if (delivredQty < itemPart.quantity) {
        isArchivable = false;
        break;
      }
    }
    return isArchivable;

  }
  // https://material.angular.io/components/snack-bar/overview
  // evolution : http://www.eduforbetterment.com/snackbar-model-in-angualr/
  // 2021-05 : https://stackblitz.com/edit/angular-material-snackbar-example
  // 2021-05 : https://stackblitz.com/edit/angular-snackbar
  openSnackBar(message: string, action: string): void {
    let actionCur = action;
    if (action === 'No-Action') {
      actionCur = '';
    }
    this.snackBar.open(message, actionCur, {
      duration: 7000,
      panelClass: ['notif-works']
    });
  }
  selectedTabChange(origin: string, matTabSelected: MatTabChangeEvent): void {
    switch (matTabSelected.index) {
      case 0: { // new
        this.tabSelected = 0;
        this.readOnly = false;
        this.tabSelectedLoad();
        break;
      }
      case 1: { // waiting 
        this.tabSelected = 1;
        this.readOnly = false;
        this.tabSelectedLoad();
        break;
      }
      case 2: { // waiting 
        this.tabSelected = 2;
        this.readOnly = true;
        this.tabSelectedLoad();
        break;
      }
    }
  }
  tabSelectedLoad() {
    switch (this.tabSelected) {
      case 0: { // new
        this.getWorksList('wharehouseMan-new', this.tabSelected);
        break;
      }
      case 1: { // waiting 
        this.getWorksList('wharehouseMan-waiting', this.tabSelected);
        break;
      }
      case 2: { // waiting 
        this.getWorksList('wharehouseMan-history', this.tabSelected);
        break;
      }
    }
  }
  refresh(): void {
    this.tabSelectedLoad();
  }
  settingOddEven(): void {
    let i = 0;
    for (const item of this.rowsWorks) {
      item.odd = this.oddEven(i);
      i++;
    }
  }
  oddEven(idx: number): boolean {
    return (idx % 2 !== 0 ? true : false);
  }
  currentTabSelected(tabName: string): void {
   
    switch (tabName) {
      case 'deliveriesNew': {
        break;
      }
      case 'deliveriesWaiting': {
        break;
      }
      case 'deliveriesArchives': {
        break;
      }
    }
  }
  archiveRow(idx: number ): void {
    const wksInfolinks = this.rowsWorks[idx].wksInfolinks;
    this.displayParts = false;
    this.registerInflAppli(wksInfolinks,  'wharehouseMan-history', idx, true);

  }
  activeRow(idx: number ): void {
    const wksInfolinks = this.rowsWorks[idx].wksInfolinks;
    this.displayParts = false;
    this.registerInflAppli(wksInfolinks,  'wharehouseMan-waiting', idx, true);

  }
  copyWorkIdToClipBoard(idx: number): void {
    const workId = this.rowsWorks[idx].workId;
    this._wksCentralService.copyToClipboard(workId);
    this.toastr.success(this._translateService.instant('workIdCopied'), workId,
      {positionClass : 'toast-center-center'}
    );
  }
  setClickedWork(idx: number): void {
    // this.rowsWorks[idx].isSelected = true;
    let i = 0;
    this.displayParts = false;
    for (const item of this.rowsWorks) {
      if (i === idx) {
        item.isSelected = true;
        this.displayListParts(i);
        i++;
        continue;
      }
      item.isSelected = false;
      item.isCollapsed = true;
      i++;
    }
  }
  displayListParts(idx: number): void {
    // PartsRequirement[];
    this.idxToDisplay = idx;
    this.displayParts = true; 

  }
  collapsedOther(idx: number, isCollapsed: boolean): void {

    const nolocalCollapsed = !isCollapsed;
    let i = 0;
    for (const item of this.rowsWorks) {
      item.isSelected = false;
      if (i === idx) {
        if (nolocalCollapsed) {
          item.isSelected = true;
        }
        i++;
        continue;
      }
      item.isCollapsed = true;
      i++;
    }
  } 
  async getWorkData(workId: string): Promise<WksWorksModel> {

    const workData = await this.getWorkUUID(this._userService.getUserLogged().entity, this._userService.getUserLogged().userlang, workId);
    return workData;
  }
  getOwnerCur(ownerId: string): void {
    this.getOwner(ownerId)
    .then ((ownerReturn: WksBusinessModel) => {
          const ownerCur = ownerReturn;
          }
      ); // end customer
  }
  getOwner(ownerId: string) {    
    return new Promise((resolve, reject) => {
      this._wksCentralService.getOwner(this._userService.getUserLogged().entity, ownerId)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          const ownerCur = data.body as WksBusinessModel;
          resolve(ownerCur);
        }, err => {
          console.log('getOwner' + err.message);
          if (err.status === 404) {
            
          }
          reject(err.status);
        }
      );
    });
  }    
  getWorkUUID(_entity: string, _langUser: string, _uuid: string) {

    return  new Promise<WksWorksModel>((resolve, reject) => {
      this._wksCentralService.getWorksById(_entity, _langUser, _uuid)
      .subscribe(
        data => {
          const response = data.body ;
          
          resolve(response);
        },
        err => {
          console.log('getWorkUUID' + err.message);
          reject(err);
        });
      }
    );
  }
  partSuppliesMovement($event: WorkInputEvent): void {
    // console.log(JSON.stringify($event));
    this.rowsWorks[$event.iRow].partsStock = $event.partsStock;
    const workCur = this.fillModel($event);
    this.registerWork(workCur, $event.iRow);
    this.registerInflAppli(this.rowsWorks[$event.iRow].wksInfolinks, $event.inflAppli, $event.iRow);
    if (this.ctrlIsArchivable(this.rowsWorks[$event.iRow].partsStock)) {
      this.archiveRow($event.iRow);
    }
  }

  getWorksList( _inflAppli: string, idxTab: number): void {
    this.isLoadingData = true;
    this.displayErrorMsg = false;
    this.errorMsg = '';
    this.readStock = false;
    if (idxTab < 2) {
      this.readStock = true;
    }
    // this.cd.detectChanges(); // Forcer Angular à re-vérifier la vue
    this._wksCentralService.getInfolinksWorksList(this._userService.getUserLogged().entity, _inflAppli,  this._userService.getUserLogged().userlang)
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        const dataList = data.body as any[][];
        this.affectData(_inflAppli, dataList);
        
        this.isLoadingData = false;
      },
      err => {
        this.rowsWorks = [];
        this.isLoadingData = false;
        this.errorMsg = this._translateService.getTranslate(this.labelsTabs[idxTab]) + ' : ' + this._translateService.getTranslate('noDataFound');
        this.displayErrorMsg = true;
        console.log(JSON.stringify(err));
      }
    );
  }
  affectData(_inflAppli: string, dataList: any[][]): void {
    this.rowsWorks = [];
    for (const rowData of dataList) {
      const newRow = this.buildRowWork(_inflAppli, rowData);
      this.rowsWorks.push(newRow);
    }
    this.settingOddEven();
  }
 
  fillModel(eventMovenent: WorkInputEvent): WksWorksModel {
      
    const wksWorkCard = this.rowsWorks[eventMovenent.iRow].work;
    let workJsonData: WorkJsonData ;
    if (wksWorkCard.workJsonData) {
      workJsonData = JSON.parse(wksWorkCard.workJsonData) as WorkJsonData;
    } else {
      workJsonData = JSON.parse('{}');
    }
    if (eventMovenent) {
      workJsonData.partsStock = eventMovenent.partsStock;
    }

    wksWorkCard.workJsonData = JSON.stringify(workJsonData);
    return wksWorkCard;
  }
  registerWork(wksWorksCard: WksWorksModel, iRow: number): void {

    this._wksCentralService.saveWksWorks(wksWorksCard, 'update')
    .subscribe(
      returnValue => {
        const wksWorksReturn = returnValue.body as WksWorksModel;
        this.rowsWorks[iRow].work = wksWorksReturn;
      },
      (err) => {
        console.log (JSON.stringify(err));
      }
    );
  }
  registerInflAppli(wksInfolinks: WksInfolinks, inflAppli: string, iRow: number, deleteRow?: boolean): void  {
    const wksInfolinksTmp = JSON.parse(JSON.stringify(wksInfolinks));
    wksInfolinksTmp.inflAppli = inflAppli;
    this._wksCentralService.saveWksInfolinks(wksInfolinksTmp, 'updateLink')
    .subscribe(
      returnValue => {
        if (deleteRow) {
          this.rowsWorks.splice(iRow, 1);
        } else { 
          const wksInfolinksReturn = returnValue.body as WksInfolinks;
          this.rowsWorks[iRow].wksInfolinks = wksInfolinksReturn;
        }
      },
      (err) => {
        console.log (JSON.stringify(err));
      }
    );
  }
}
